<div id="container">
  <div id="icon">
    <i class="{{'mdi ' + size}}" [ngClass]="icon" [style.color]="colour"></i>
  </div>
  <div class="line-break">
    <ng-content></ng-content>
  </div>
</div>
